module Widgets.Form.EmailInput where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import GraphQL.Shape (QueryField(..))
import Widgets.Form.Class (class FormWidget, fieldAccessProps, formWidgetState, fieldClass, fieldId, setFromJson)
import Widgets.Form.Common (widgetLabelS)


newtype EmailInput = EmailInput EmailInputType
derive newtype instance showEmailInput :: Show EmailInput
type EmailInputType =
    { id :: String
    , label :: String
    , cls :: String
    , placeholder :: Maybe String
    , value :: String
    }

instance emailInputFW :: FormWidget EmailInput where
    getId (EmailInput state) = state.id
    isLeaf _ = true
    asField (EmailInput state) = Just $ QScalar state.id
    fieldPaths fc (EmailInput state) = [ fieldId fc state.id ]

    toWidget fc (EmailInput state) = formWidgetState <$> D.div
        [ P.key id, P.className $ fieldClass state ]
        [ widgetLabelS fc state [ P.className "block w-full" ]
        , D.input
            ( [ P._type "email", P._id id, P.name id, P.value state.value
            , P.className "widget-input"
            , P.placeholder $ fromMaybe "" state.placeholder
            , EmailInput <$> state { value = _ } <$> P.unsafeTargetValue <$> P.onInput
            ] <> fieldAccessProps fc state.id )
        ]
      where id = fieldId fc state.id

    getData _ (EmailInput state) = J.fromString state.value

    setData _ st@(EmailInput state) =
        setFromJson st $ \val -> Right $ EmailInput $ state { value = val }
